export const MODES = ['HP', 'SND', 'CTL'];

// Season-specific map pools (extend as needed)
export const seasonMapPools = {
  '2025': {
    HP: ['Summit', 'Hacienda', 'Apocalypse', 'Slums', 'Combine'],
    SND: ['Tunisia', 'Firing Range', 'Kurohana', 'Standoff', 'Coastal'],
    CTL: ['Raid', 'Takeoff', 'Crossfire'],
  },
  '2026': {
    HP: ['Summit', 'Hacienda', 'Takeoff', 'Arsenal', 'Combine'],
    SND: ['Tunisia', 'Firing Range', 'Slums', 'Meltdown', 'Coastal'],
    CTL: ['Raid', 'Standoff', 'Crossroads'],
  },
};

export const regions = [
  'Garena', 'Japan', 'China', 'India', 'Africa', 
  'Europe', 'LATAM', 'North_America'
];

export const operators = [
  'CLAW', 'ANNIHILATOR', 'DEATH MACHINE', 'EQUALIZER', 
  'GRAVITY SPIKES', 'GRAVITY VORTEX', 'PURIFIER', 
  'SPARROW', 'TEMPEST', 'WAR MACHINE'
];

export const NUMBER_FIELDS = [
  'Score', 'K', 'D', 'A', 'HillTime', 'Impact',
  'TotalDamage', 'CaptureKills', 'DistanceMoved', 'OperatorValue',
  'ADR', 'FirstBloods', 'Clutches1v1', 'Damage', 'PF', 'PA'
];

export const PROPAGATE_FIELDS = [
  'Region',
  'VS',
  'MatchType',
  'MatchTypeId',
  'MatchCategory',
  'MatchTypeRegion',
  'Map',
  'Date',
  'WinLose',
  'PF',
  'PA'
];

export const MAX_ROWS = 5;

export const essentialFieldsHP = ['Player', 'Score', 'K', 'D', 'A', 'HillTime', 'Impact', 'Operator'];
export const essentialFieldsSND = ['Player', 'Score', 'K', 'D', 'A', 'Impact'];
export const essentialFieldsCTL = ['Player', 'Score', 'K', 'D', 'A', 'Impact', 'Operator'];

export const getTemplateHeaders = (mode) => {
  if (mode === 'HP') {
    return [
      'Team', 'Region', 'VS', 'Date', 'ModeID', 'Operator', 'Player',
      'Score', 'K', 'D', 'A', 'HillTime', 'Impact', 'TotalDamage', 'CaptureKills', 'DistanceMoved', 'OperatorValue'
    ];
  }
  if (mode === 'SND') {
    return [
      'Team', 'Region', 'VS', 'Date', 'ModeID', 'Player',
      'Score', 'K', 'D', 'A', 'Impact', 'ADR', 'FirstBloods', 'Clutches1v1'
    ];
  }
  if (mode === 'CTL') {
    return [
      'Team', 'Region', 'VS', 'Date', 'ModeID', 'Operator', 'Player',
      'Score', 'K', 'D', 'A', 'Impact', 'Damage', 'CaptureKills', 'OperatorValue'
    ];
  }
  return [];
};

